<template>
  <v-form lazy-validation ref="profileForm" v-model="isFormValid">
    <v-container grid-list-xs>
      <v-layout row wrap>
        <v-flex xs12>
          <h2 class="display-1 mb-0">Benutzerprofil</h2>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field :rules="[rules.required]" label="Vorname" v-model="user.firstname"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field :rules="[rules.required]" label="Nachname" v-model="user.lastname"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field :rules="[rules.required, rules.email]" label="E-Mail" readonly
                        v-model="user.email"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs11>
          <v-text-field label="Password" type="password" v-model="user.password"></v-text-field>
        </v-flex>
        <v-flex xs1>
        </v-flex>
      </v-layout>
      <v-layout align-center row wrap>
        <v-flex xs11>
          <v-text-field label="Password wiedeholen" type="password"
                        v-model="passwordRepeat"></v-text-field>
        </v-flex>
        <v-flex v-if="user.password !== ''" xs1>
          <v-icon color="success" v-if="passwordsEqual">fal fa-check</v-icon>
          <v-icon color="error" v-else>fal fa-exclamation-circle</v-icon>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex class="text-xs-right" xs12>
          <v-btn @click="saveProfile">Speichern</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar v-model="snackbarSaved" bottom color="success" right>
      Benutzerprofil wurde gespeichert.
      <v-btn @click="snackbarSaved = false" flat>
        <v-icon>fal fa-times</v-icon>
      </v-btn>
    </v-snackbar>
  </v-form>
</template>

<script>
  export default {
    name: 'Profile',
    created() {
      if (this.token !== '') {
        this.$store.dispatch('loadProfile')
      }
    },
    watch: {
      token() {
        if (this.token !== '') {
          this.$store.dispatch('loadProfile')
        }
      }
    },
    methods: {
      saveProfile() {
        if (this.$refs.profileForm.validate() && this.passwordsEqual) {
          this.$store.dispatch('updateProfile').then(() => {
            this.snackbarSaved = true
            this.passwordRepeat = ''
          })
        }
      }
    },
    computed: {
      token() {
        return this.$store.state.token
      },
      passwordsEqual() {
        return this.user.password === this.passwordRepeat
      },
      user() {
        return this.$store.state.user
      }
    },
    data: () => ({
      isFormValid: false,
      snackbarSaved: false,
      passwordRepeat: '',
      rules: {
        required: value => !!value || 'Pflichtfeld',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Bitte geben Sie eine gültige E-Mailadresse ein.'
        }
      }
    })
  }
</script>

<style>

</style>
